import { createSlice } from "@reduxjs/toolkit";
import _ from "lodash";

const initialState = {
  selectedDevice: {},
  showAssignForm: false,
  companyCampaigns: {},
  companyGroups: {},
  // Raw RTDB `connected` flag per serial — NOT a device status signal
  // (status is 100% backend-computed since the unified-presence rollout,
  // 2026-10-06: see device.connectivity.state/device.presence_status,
  // resolveDeviceOnline/resolveDeviceStatus in utils/helpers.js). Campaign
  // name needs the raw flag specifically: RTDB's
  // `current_campaign` can be a populated-but-stale string (old name) when
  // the device changed campaigns via the REST fallback while its WebSocket
  // was down, which is NOT distinguishable from a correct value without
  // knowing whether RTDB is actually connected right now. See
  // RtdbConnectedMirror (DeviceLastLoginListener.jsx — narrowed to this one
  // purpose, see that file's doc).
  rtdbConnected: {},
  deviceFilters: {
    // status: "",
    // name: "",
    isOnline: null,
    order: "DESC",
    group_order: "DESC",
    group_id: ""
  },
  rerender: false,
  loading: true,
  editRotation: false,
  device: {
    name: null,
    serial_name: "",
  },
  selectedCampaign: "",
  selectedCountry: {},
  selectedGroup: {},
  isDevice: false,
  playingOnCorner: "",
  playingOnPlayground: "",
  playingOnBanner: "",
  paused: {},
  scheduleId: "",
  playbackStatus: {} // { [areaId]: { currentItemId, elapsed, totalDuration, isPlaying } }
};

//the actions
const deviceSlice = createSlice({
  name: "device",
  initialState,
  reducers: {
    setPaused(state, action) {
      if (action.payload && action.payload.id) {
        state.paused[action.payload.id] = action.payload.paused;
      }
    },
    setPlaybackStatus(state, action) {
      if (action.payload && action.payload.id) {
        state.playbackStatus[action.payload.id] = {
          ...state.playbackStatus[action.payload.id],
          ...action.payload
        };
      }
    },
    setScheduleId(state, action) {
      state.scheduleId = action.payload;
    },
    setPlayingOnCorner(state, action) {
      state.playingOnCorner = action.payload;
    }, setPlayingOnPlayground(state, action) {
      state.playingOnPlayground = action.payload;
    }, setPlayingOnBanner(state, action) {
      state.playingOnBanner = action.payload;
    },
    setSelectedDevice(state, action) {
      state.selectedDevice = _.isEmpty(action.payload) ? {} : { ...state.selectedDevice, ...action.payload };
    },
    setShowAssignForm(state, action) {
      state.showAssignForm = action.payload;
    },
    setCompanyCampaigns(state, action) {
      state.companyCampaigns = action.payload;
    },
    setCompanyGroups(state, action) {
      state.companyGroups = action.payload;
    },
    setRtdbConnected(state, action) {
      state.rtdbConnected = { ...state.rtdbConnected, ...action.payload };
    },
    setDeviceFilters(state, action) {
      state.deviceFilters = { ...state.deviceFilters, ...action.payload };
    },
    setRerender(state, action) {
      state.rerender = action.payload;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setEditRotation(state, action) {
      state.editRotation = action.payload;
    },
    setDevice(state, action) {
      state.device = action.payload;
    },
    setSelectedCampaign(state, action) {
      state.selectedCampaign = action.payload;
    },
    setSelectedCountry(state, action) {
      state.selectedCountry = action.payload;
    },
    setSelectedGroup(state, action) {
      state.selectedGroup = action.payload;

    },
    setIsDevice(state, action) {
      state.isDevice = action.payload;

    },
    resetState: (state) => {
      state.selectedCountry = {};
      state.selectedDevice = {};
      state.selectedGroup = {};
    }
  },
});

export const {
  setPaused,
  setPlaybackStatus,
  setPlayingOnCorner,
  setPlayingOnPlayground,
  setPlayingOnBanner,
  setSelectedDevice,
  setShowAssignForm,
  setCompanyCampaigns,
  setRtdbConnected,
  setDeviceFilters,
  setRerender,
  setLoading,
  setEditRotation,
  setDevice,
  setSelectedCampaign,
  setSelectedCountry,
  setCompanyGroups,
  setSelectedGroup,
  setIsDevice,
  resetState, setScheduleId
} = deviceSlice.actions;

export default deviceSlice.reducer;
